export default __webpack_public_path__ + "static/media/blueBoat.ba74b35f.svg";